import type { TestimonialFragment } from '@/lib/types/datocms/graphql/generated'
import Image from 'next/image'
import { StructuredText, renderNodeRule } from 'react-datocms'
import { isParagraph } from 'datocms-structured-text-utils'
import clsx from 'clsx'
import CtaDefault from './ui/cta/CtaDefault'

export default function TestimonialCard({
	id,
	image,
	personName,
	jobTitle,
	quote,
	cta,
	className,
	onClick,
}: Readonly<TestimonialFragment> & {
	className?: string
	onClick?: () => void
}) {
	return (
		<div
			key={id as string}
			onClick={() => {
				onClick?.()
			}}
			className={`carousel-card relative text-left rounded-xl overflow-hidden h-[540px] @5xl:h-[670px] max-md:border-b-8 border-blue after:content-[''] after:absolute after:inset-0 after:bg-gradient-to-t after:from-black/40 after:to-transparent transition-all duration-500 ease-s-ease text-white bg-white-frosted ${className}`}
		>
			{image?.[0]?.url && (
				<Image
					src={image?.[0]?.url as string}
					alt={(image?.[0]?.alt as string) ?? 'Testimonial Image'}
					width={image?.[0]?.width as number}
					height={image?.[0]?.height as number}
					className={clsx(
						'absolute w-full h-full inset-0 object-cover  transition-transform duration-500 m-ease'
					)}
					sizes="(max-width: 1024px) 342px, 30vw"
				/>
			)}

			<div className="absolute bottom-8 md:bottom-10 inset-x-6 md:inset-x-10 z-10">
				<div className="relative sm:pl-3 max-sm:before:hidden before:content-[''] before:absolute before:w-1 before:-left-0 before:inset-y-1 before:bg-blue">
					{personName && <p className="text-2xl font-semibold">{personName}</p>}
					{jobTitle && <p>{jobTitle}</p>}
				</div>
				{quote && (
					<blockquote className="text-2xl leading-tight pt-6">
						<StructuredText
							data={quote}
							customNodeRules={[
								renderNodeRule(isParagraph, ({ children, key }) => {
									return <span key={key}>&ldquo;{children}&rdquo;</span>
								}),
							]}
						/>
					</blockquote>
				)}

				{cta && (
					<CtaDefault
						cta={{
							__typename: 'NavigationItemRecord',
							id: cta.id,
							label: cta.label,
							internalLink: cta.internalLink,
							useExternalLink: cta.useExternalLink,
							openInNewWindow: cta.openInNewWindow,
						}}
						className="mt-4"
					/>
				)}
			</div>
		</div>
	)
}
